export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9206.16e92d54.jpg";